<template>
    <div
        class="stickers-uploader"
        @dragover="fileInside"
        @dragleave="fileOutside"
        @drop="fileDrop"
    >
        <div
            class="header"
            :class="allStickersIsLoading ? 'header_disabled' : ''"
        >
            <label
                for="upload-sticker"
                v-if="allStickers.filter(s => !!s.user_id).length < maxCount"
                class="header-container"
                :class="waitingNewSticker ? 'upload-btn_disabled' : ''"
            >
                <Button
                    type="primary"
                    class="upload-btn"
                >
                    <svg class="upload-btn__icon" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                        <path fill-rule="evenodd" d="M7.583 0v5.416H13v2.167H7.583V13H5.417l-.001-5.417H0V5.417l5.416-.001V0h2.167z" />
                    </svg>

                    <span class="upload-btn__text">{{ $t('stickers.uploader.uploadSticker') }}</span>
                </Button>

                <input
                    type="file"
                    id="upload-sticker"
                    @change="uploadSticker"
                    style="display: none"
                >
            </label>

            <div
                class="header__limit"
                v-if="allStickers.filter(s => !!s.user_id).length"
            >
                <div class="header__limit-desc">{{ $t('stickers.uploader.stickersUploaded', {
                    current: allStickers.filter(s => !!s.user_id).length, 
                    all: maxCount,
                }) }}</div>

                <div class="header__limit-bar">
                    <div
                        class="header__limit-progress"
                        :style="{width: `${ 100 / maxCount * allStickers.filter(s => !!s.user_id).length }%`}"
                    />
                </div>
            </div>
        </div>

        <div
            class="filter"
            :class="allStickersIsLoading ? 'filter_disabled' : ''"
        >
            <div>
                <span>{{ $t('stickers.uploader.show') }}:</span>

                <div
                    class="filter__select"
                    ref="optionList"
                    :class="showFilter ? 'filter__select_active' : ''"
                >
                    <span
                        class="filter__select-title"
                        @click="toggleFilter"
                    >
                        {{ filterOption === 'user' ? $t('stickers.uploader.uploadedStickers') : filterOption === 'da' ? $t('stickers.uploader.defaultStickers') : $t('stickers.uploader.allStickers') }}
                    </span>
                    <div class="filter__select-list">
                        <span @click="option('all')">{{ $t('stickers.uploader.allStickers') }}</span>
                        <span @click="option('da')">{{ $t('stickers.uploader.defaultStickers') }}</span>
                        <span @click="option('user')">{{ $t('stickers.uploader.uploadedStickers') }}</span>
                    </div>
                </div>
            </div>

            <div>
                <span
                    class="toggle-link"
                    @click="toggleAll(true)"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10">
                        <g fill="none" fill-rule="evenodd">
                            <path d="M0 7.45l3.768 1.946L6.992.05M5.586 8.093l2.182 1.253L10.992 0" />
                        </g>
                    </svg>

                    <span>{{ $t('stickers.uploader.enableAll') }}</span>
                </span>

                <span
                    class="toggle-link"
                    @click="toggleAll(false)"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10">
                        <g fill="none" fill-rule="evenodd">
                            <path d="M1 0l9.5 9.5M10.5 0L1 9.5" />
                        </g>
                    </svg>

                    <span>{{ $t('stickers.uploader.disableAll') }}</span>
                </span>
            </div>
        </div>

        <div class="content">
            <Loader
                v-if="allStickersIsLoading"
            />

            <div
                class="content__scroll-box"
                v-bar
            >
                <div>
                    <div class="cf" style="padding: 50px 20px 80px;">
                        <div
                            v-for="(sticker, i) in filteredList"
                            :key="i"
                            class="sticker"
                            :class="[(sticker.is_active ? 'sticker_active' : ''), (disabledSticker.includes(sticker.id) ? 'sticker_disabled' : '')]"
                        >
                            <div
                                class="sticker-preview"
                                @click="toggleSticker(sticker.id, !sticker.is_active)"
                            >
                                <img
                                    :src="sticker.url"
                                    draggable="false"
                                >

                                <div
                                    class="is-active-label"
                                    v-if="sticker.is_active"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                        <g fill="none" fill-rule="evenodd">
                                            <path fill="#FFF" fill-rule="nonzero" d="M8.847 12.779l5.112-6.745a.9.9 0 1 1 1.434 1.087L9.69 14.647a.9.9 0 0 1-1.32.125l-3.991-3.596a.9.9 0 0 1 1.205-1.337l3.263 2.94z" />
                                        </g>
                                    </svg>
                                </div>
                            </div>

                            <div
                                class="del-button"
                                v-if="sticker.user_id"
                                @click="delSticker(sticker.id)"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                                    <path fill-rule="nonzero" d="M8.176 5L8 15h1.824L10 5H8.176zM5.824 5H4l.176 10H6L5.824 5zm5.347 10.773l-.001.03c0 .056-.052.103-.116.103H3.17c-.064 0-.117-.047-.117-.104l-.4-11.082H.611l.401 11.099c.01 1.05.974 1.9 2.157 1.9h7.884c1.183 0 2.146-.85 2.156-1.9l.402-11.1H11.57l-.4 11.054zm-.927-13.808L9.881 0H3.939l-.364 1.965H0V4h14V1.965h-3.756z" />
                                </svg>
                            </div>
                        </div>

                        <div
                            class="sticker-placeholder"
                            v-if="waitingNewSticker"
                        >
                            <div class="sticker-placeholder-preview">
                                <Loader
                                    v-if="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer" />

        <div
            class="cape"
            v-if="isFileDrag"
        >
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 471.2 471.2" style="enable-background:new 0 0 471.2 471.2;" xml:space="preserve">
                <g fill="#f57d07">
                    <path d="M457.7,230.15c-7.5,0-13.5,6-13.5,13.5v122.8c0,33.4-27.2,60.5-60.5,60.5H87.5c-33.4,0-60.5-27.2-60.5-60.5v-124.8 c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v124.8c0,48.3,39.3,87.5,87.5,87.5h296.2c48.3,0,87.5-39.3,87.5-87.5v-122.8 C471.2,236.25,465.2,230.15,457.7,230.15z" />
                    <path d="M159.3,126.15l62.8-62.8v273.9c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V63.35l62.8,62.8c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.8-85.8c-2.5-2.5-6-4-9.5-4c-3.6,0-7,1.4-9.5,4l-85.8,85.8 c-5.3,5.3-5.3,13.8,0,19.1C145.5,131.35,154.1,131.35,159.3,126.15z" />
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ACTIONS as ACTIONS_STICKERS } from '../../store/stickersUploader'

import Loader from '../../components/ui/loader'
import Button from '../../components/ui/button'

export default {
    name: 'StickersUploader',

    components: {
        Loader,
        Button,
    },

    data: () => {
        return {
            isFileDrag: false,
            showFilter: false,
            filterOption: 'all',
        }
    },


    computed: {
        ...mapGetters({
            maxCount: 'maxCount',
            allStickers: 'allStickers',
            allStickersIsLoading: 'allStickersIsLoading',
            disabledSticker: 'disabledSticker',
            waitingNewSticker: 'waitingNewSticker',
        }),

        filteredList() {
            switch (this.filterOption) {
            case 'user':
                return this.allStickers.filter(el => el.user_id)
            case 'da':
                return this.allStickers.filter(el => !el.user_id)
            default:
                return this.allStickers
            }
        }
    },

    mounted() {
        this.$store.dispatch(ACTIONS_STICKERS.FETCH_STICKERS)
    },

    destroyed() {
        this.$store.dispatch(ACTIONS_STICKERS.CLEAR_STICKERS)
    },

    created() {
        document.addEventListener('click', this.closeFilter)
    },

    beforeDestroy() {
        document.removeEventListener('click', this.closeFilter)
    },

    methods: {
        toggleFilter() {
            this.showFilter = !this.showFilter
        },

        uploadSticker(event) {
            this.$store.dispatch(ACTIONS_STICKERS.UPLOAD_STICKER, event.target.files[0])
        },

        fileInside(event) {
            if (this.allStickers.filter(s => !!s.user_id).length >= this.maxCount || this.waitingNewSticker) return

            event.preventDefault()
            this.isFileDrag = true
            return false
        },

        fileOutside(event) {
            if (this.allStickers.filter(s => !!s.user_id).length >= this.maxCount || this.waitingNewSticker) return

            event.preventDefault()
            this.isFileDrag = false
            return false
        },

        fileDrop(event) {
            if (this.allStickers.filter(s => !!s.user_id).length >= this.maxCount || this.waitingNewSticker) return

            event.preventDefault()
            this.isFileDrag = false
            this.$store.dispatch(ACTIONS_STICKERS.UPLOAD_STICKER, event.dataTransfer.files[0])
            return false
        },

        delSticker(id) {
            this.$store.dispatch(ACTIONS_STICKERS.DEL_STICKER, id)
        },

        option(str) {
            this.filterOption = str
            this.showFilter = false
        },

        closeFilter(event) {
            if (!this.$refs.optionList.contains(event.target)) {
                this.showFilter = false
            }
        },

        toggleSticker(id, newStatus) {
            return this.$store.dispatch(ACTIONS_STICKERS.TOGGLE_STICKERS, {
                stickers_ids: [id],
                is_active: newStatus,
            })
        },

        toggleAll(newStatus) {
            switch (this.filterOption) {
            case 'user':
                return this.$store.dispatch(ACTIONS_STICKERS.TOGGLE_STICKERS, {
                    stickers_ids: this.allStickers.filter(el => el.user_id).map(el => el.id),
                    is_active: newStatus,
                })
            case 'da':
                return this.$store.dispatch(ACTIONS_STICKERS.TOGGLE_STICKERS, {
                    stickers_ids: this.allStickers.filter(el => !el.user_id).map(el => el.id),
                    is_active: newStatus,
                })
            default:
                return this.$store.dispatch(ACTIONS_STICKERS.TOGGLE_STICKERS, {
                    stickers_ids: this.allStickers.map(el => el.id),
                    is_active: newStatus,
                })
            }
        },
    },
}
</script>

<style lang='scss' scoped>
@import '../../../sass/_variables.scss';
@import '../../../sass/_mixins.scss';

.stickers-uploader {
    font-size: 13px;
    line-height: 1.3;
    position: relative;
}

.header {
    background-color: #272727;
    padding: 15px 30px;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;

    &_disabled {
        opacity: .5;
        pointer-events: none;
    }

    &__limit {
        color: #f1f1f1;
        display: inline-block;
        vertical-align: middle;
        cursor: default;

        &-desc {
            margin-bottom: 10px;
        }

        &-bar {
            background-color: #393939;
            width: 100%;
            height: 6px;
            border-radius: 3px;
            overflow: hidden;
        }

        &-progress {
            background-image: linear-gradient(265deg, #f59c07, #f57507);
            width: 0;
            height: 6px;
            border-radius: 3px;
            transition: all .2s;
        }
    }
}

.filter {
    position: absolute;
    z-index: 2;
    padding: 20px 10px;
    top: 75px;
    left: 20px;
    right: 20px;
    background-image: linear-gradient(0deg, transparent, #1f1f1f 75%);
    color: #f1f1f1;
    display: flex;
    justify-content: space-between;

    &_disabled {
        opacity: .5;
        pointer-events: none;
    }

    &__select {
        display: inline-block;
        margin-left: 5px;
        position: relative;

        &-title {
            color: #f57d07;
            cursor: pointer;
            position: relative;
            user-select: none;

            &:after {
                display: block;
                content: '';
                position: absolute;
                border-top: 5px solid #f57e06;
                border-right: 4px solid transparent;
                border-bottom: 5px solid transparent;
                border-left: 4px solid transparent;
                right: -15px;
                top: 6px;
                transition: all .2s;
            }
        }

        &-list {
            display: none;
            position: absolute;
            bottom: -10px;
            left: 0;
            min-width: 100%;
            transform: translateY(100%);
            background-color: #272727;
            border-radius: 3px;
            z-index: 2;

            span {
                display: block;
                line-height: 20px;
                padding: 5px 15px;
                cursor: pointer;
                user-select: none;
                white-space: nowrap;

                &:hover {
                    color: #f57d07;
                }
            }
        }
    }
}

.filter__select_active {
    .filter__select {
        &-title {
            &:after {
                border-top: 5px solid transparent;
                border-right: 4px solid transparent;
                border-bottom: 5px solid #f57e06;
                border-left: 4px solid transparent;
                top: 0;
            }
        }

        &-list {
            display: block;
        }
    }
}

.content {
    padding: 75px 0 0;
    background-color: #1f1f1f;
    position: relative;
    z-index: 1;
    height: 600px;

    &__scroll-box {
        height: 100%;
        width: 100%;
    }
}

.footer {
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background-image: linear-gradient(180deg, transparent, #1f1f1f);
    pointer-events: none;
}

.stickers-uploader__buttons {
    position: absolute;
    z-index: 2;
    left: 30px;
    bottom: 20px;

    .btn-shadow {
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    }
}

.sticker-placeholder {
    position: relative;
    float: left;
    width: 25%;
    padding: 10px;
    cursor: default;

    &:before {
        display: block;
        content: '';
        padding-top: 100%;
        float: left;
    }

    &-preview {
        width: 100%;
        background-color: #303030;
        border-radius: 5px;
        border: 2px solid transparent;
        position: relative;

        &:before {
            display: block;
            content: '';
            padding-top: 100%;
        }
    }
}

.sticker {
    position: relative;
    float: left;
    width: 50%;
    padding: 10px;
    cursor: default;

    @include bp('sm') {
        width: 25%;
    }

    &:before {
        display: block;
        content: '';
        padding-top: 100%;
        float: left;
    }

    &_disabled {
        opacity: .5;
        pointer-events: none;
    }

    &-preview {
        width: 100%;
        background-color: #303030;
        border-radius: 5px;
        border: 2px solid transparent;
        position: relative;
        cursor: pointer;

        &:before {
            display: block;
            content: '';
            padding-top: 100%;
        }

        img {
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 70%;
            max-height: 70%;
        }
    }
}

.sticker_active {
    .sticker {
        &-preview {
            border-color: #f57d07;
        }
    }
}

.is-active-label {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    background-image: linear-gradient(265deg, #f59c07, #f57507);
    border-radius: 50%;
}

.del-button {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 20px;
    bottom: 20px;
    background-color: #4b4b4b;
    border-radius: 3px;
    cursor: pointer;

    svg {
        fill: #B0B0B0;
    }

    &:hover {
        svg {
            fill: #fff;
        }
    }
}

.is-active-label,
.del-button {
    svg {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

.cape {
    position: absolute;
    z-index: 10;
    top: 10px;
    right: 10px;
    bottom: 10px;
    left: 10px;
    background-color: rgba(#1f1f1f, .75);
    border: 3px dashed #f57d07;
    border-radius: 5px;
    pointer-events: none;

    svg {
        display: block;
        max-width: 200px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

.upload-btn_disabled {
    opacity: .5;
    pointer-events: none;
}

.toggle-link {
    margin-left: 30px;
    cursor: pointer;
    color: #f1f1f1;
    display: none;

    @include bp('md') {
        display: inline;
    }

    svg {
        stroke: #979797;
        margin-right: 5px;
    }

    &:hover {
        color: #f57d07;

        svg {
            stroke: #f57d07;
        }
    }
}

.upload-btn {
    padding: 12px 15px 16px !important;

    @include bp('sm') {
        padding: 12px 20px 16px !important;
    }

    &:hover {
        .upload-btn__icon {
            fill: #f57d07;
        }
    }
}

.upload-btn__icon {
    margin-right: 0 !important;
    fill: #fff;

    @include bp('sm') {
        margin-right: 10px !important;
    }
}

.upload-btn__text {
    display: none;

    @include bp('sm') {
        display: inline;
    }
}

.header-container {
    margin-right: 15px;

    @include bp('sm') {
        margin-right: 25px;
    }
}
</style>
